import React from 'react';
import styled from '@emotion/styled';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { Button, Spinner, TextInput } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import {
  ErrorMessage,
  SuccessMessage,
} from 'components/Subscribe/FlashMessages';

type Props = {
  /**
   * TODO: Improve this type
   * I tried to get the right types from ZDS using
   * Pick<TextInputProps, 'color'> but that didn't work.
   */
  inputBackgroundColor: 'grey100' | 'white';
  loading: boolean;
  error: boolean;
  sectionToTrack: string;
  success: boolean;
  onSubmit: (email: string) => void;
};

export const SubscribeForm = ({
  onSubmit,
  loading,
  error,
  sectionToTrack,
  success,
  inputBackgroundColor,
}: Props) => {
  const [email, setEmail] = React.useState<string>('');
  const trackEvent = useTrackEvent();

  if (loading) {
    return <Spinner size="small" />;
  }

  if (error) {
    return (
      <ErrorMessage>Oops! We had trouble subscribing this email.</ErrorMessage>
    );
  }

  if (success) {
    trackEvent('call_to_action', {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: 'email_subscribe_confirm',
      cta_raw_text: 'email address submitted',
      cta_location: sectionToTrack,
      cta_goal: 'email_subscribe',
      link_destination: '',
      signup_type: '',
    });

    return (
      <SuccessMessage>Excellent! You have been subscribed.</SuccessMessage>
    );
  }

  return (
    <Form
      onSubmit={(e: React.SyntheticEvent) => {
        e.preventDefault();
        onSubmit(email);
      }}
    >
      <TextInputWrapper>
        <TextInput
          ariaLabel="Email address"
          color={inputBackgroundColor}
          isRequired={true}
          onChange={(e: React.SyntheticEvent) => {
            const value = (e.target as HTMLInputElement).value;
            setEmail(value);
          }}
          onFocus={() =>
            trackEvent('call_to_action', {
              path: window.location.pathname,
              from_path: document.referrer,
              cta_name: 'email_subscribe_intent',
              cta_raw_text:
                'get productivity tips delivered straight to your inbox',
              cta_location: sectionToTrack,
              cta_goal: 'email_subscribe',
              link_destination: '',
              signup_type: '',
            })
          }
          placeholder="Email address"
          size="medium"
          type="email"
        />
      </TextInputWrapper>
      <Button hasShadow={true} type="submit">
        Subscribe
      </Button>
    </Form>
  );
};

const Form = styled.form`
  align-items: center;
  display: grid;
  grid-template-columns: max-content;
  grid-row-gap: 20px;
  ${mediaQueries.tablet} {
    grid-template-columns: repeat(2, max-content);
    grid-column-gap: 10px;
  }
`;

const TextInputWrapper = styled.div`
  width: 275px;
`;
